import { AuthError } from "./AuthError";
import { LoginError } from "./LoginError";
import { TimeoutError } from "./TimeoutError";
import { SaveContentError } from "./SaveContentError";
import { SaveSubCategoryError } from "./SaveSubCategoryError";
import { SaveUserError } from "./SaveUserError";
import { SaveGroupError } from "./SaveGroupError";
import { ChangePasswordError } from "./ChangePasswordError";
import { NotFoundError } from "./NotFoundError";
import { InternalServerError } from "./InternalServerError";
import { DeleteContentError } from "./DeleteContentError";
import { DeleteReverseRelationError } from "./DeleteReverseRelationError";
import { DeleteAllReverseRelationsError } from "./DeleteAllReverseRelationsError";
import { InsertInquiryError } from "./InsertInquiryError";
import { WebLoginError } from "./WebLoginError";
import { WebRegistrationError } from "./WebRegistrationError";
import { WebUserConfirmationError } from "./WebUserConfirmationError";
import { WebUserConfirmationResendError } from "./WebUserConfirmationResendError";
import { WebLostPasswordError } from "./WebLostPasswordError";
import { WebUserCancelationError } from "./WebUserCancelationError";
import { WebUserUpdateError } from "./WebUserUpdateError";
import { WebResetPasswordError } from "./WebResetPasswordError";

export const errorRecord = {
  NotFoundError,
  InternalServerError,
  AuthError,
  TimeoutError,
  LoginError,
  WebLoginError,
  WebRegistrationError,
  WebResetPasswordError,
  WebUserUpdateError,
  WebUserConfirmationError,
  WebUserConfirmationResendError,
  WebLostPasswordError,
  WebUserCancelationError,
  SaveContentError,
  DeleteContentError,
  DeleteReverseRelationError,
  DeleteAllReverseRelationsError,
  SaveSubCategoryError,
  SaveUserError,
  SaveGroupError,
  ChangePasswordError,
  InsertInquiryError,
};
